import type { ReactNode } from 'react';
import { Box, Flex, Panel } from '@customerio/pluma-components/react';
import { MinimalAppHeader } from './minimal-app-header';
import { ReferralSplash } from './referral-splash';
import * as styles from '../index.css';

type AuthFormLayoutProps = {
  children: ReactNode;
  /** Show the split-screen referral splash (login index only), matching Ember. */
  withReferralSplash?: boolean;
};

/**
 * Page shell for the login pages: the minimal logo header plus the current
 * step. The login index uses Ember's split-screen layout (form left, referral
 * splash right); other steps use a centered panel.
 */
export function AuthFormLayout({ children, withReferralSplash = false }: AuthFormLayoutProps) {
  if (withReferralSplash) {
    return (
      <Box style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <MinimalAppHeader showSignupCallout />
        <div className={styles.splitMain}>
          <div className={styles.splitLeft}>
            <Box className={styles.container}>
              <Panel>{children}</Panel>
            </Box>
          </div>
          <div className={styles.splitRight}>
            <ReferralSplash />
          </div>
        </div>
      </Box>
    );
  }

  return (
    <Box style={{ minHeight: '100vh' }}>
      <MinimalAppHeader />
      <Flex justifyContent="center" px="200" pt="500">
        <Box className={styles.container}>
          <Panel>{children}</Panel>
        </Box>
      </Flex>
    </Box>
  );
}
